module.exports = __webpack_public_path__ + "static/media/squarecheck.48feb092.svg";